import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../../../shared/services/logging';
import { EfaactDataService } from '../../../efaact.data-service';
import { InvoiceDetailOptionsModel } from './invoice-detail-options.model';

export const entityName = 'InvoiceDetailOption';
@Injectable({ providedIn: 'root' })
export class InvoiceDetailOptionsDataService extends EfaactDataService<InvoiceDetailOptionsModel> {
    mapItems(item: InvoiceDetailOptionsModel): InvoiceDetailOptionsModel {
        return { ...item, id: item.Invoiceviewoptionid };
    }

    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }
}
